import React, { useEffect, useState } from 'react';
import governance2 from '../../../../assets/shapes_svg/output/governance2.svg';
import { getHighlight } from '../../../../apis/Ambition';
import { useRef } from 'react';
import { PRINT_WIDTH } from '..';
import { fontReport } from '../../../../apis/util';

export const OurTransparency = () => {
  const [text1, setText1] = useState();
  const [text2, setText2] = useState();

  const [question1, setQuestion1] = useState();
  const [question2, setQuestion2] = useState();

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({ key: "declaration", setValue: setText1 });
    getHighlight({ key: "certification", setValue: setText2 });

    getHighlight({ key: "declaration_question", setValue: setQuestion1 });
    getHighlight({ key: "certification_question", setValue: setQuestion2 });
  };
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>Our Transparency</h4>
        <img src={governance2} alt="" />
      </div>
      <div className="environmentalaim__body ">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}>{question1 + "\n" + text1 +
          "\n\n" +
          question2 + "\n" + text2}</h5>
      </div>
    </div>
  );
};
